import * as types from "../constants/ActionConstants";



export const changeDataUser = (payload) => ({
    type: types.ACCOUNT_UPDATE_DATAUSER,
    payload
})
export const updateStateGame = (payload) => ({
    type: types.ACCOUNT_UPDATE_STATE_GAME,
    payload
})

